import React from "react";
import { Modal, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { AlertTriangle, Shield } from "lucide-react";

const SubscriptionCheckModal = ({ open, onClose, type }) => {
  const navigate = useNavigate();

  const handleCancel = () => {
    onClose();
    navigate("/");
  };

  const handleViewPricing = () => {
    onClose();
    navigate("/pricing");
  };

  return (
    <Modal
        title={
    <div style={{ textAlign: "center" }}>
      <div className="icon-glow">
        <Shield size={38} />
      </div>
      <div style={{ marginTop: "8px", fontSize: "20px", fontWeight: 600 }}>
        Subscription Required
      </div>
    </div>
  }
      open={open}
      onCancel={handleCancel}
      footer={[
        <Button key="pricing" type="primary" onClick={handleViewPricing}>
          View Pricing Plans
        </Button>
      ]}
      closable={false}
      maskClosable={false}
      className="sub-req-modal"
    >
      <div>
        <p style={{ fontSize: "17px", marginBottom: "10px" }}>
          You do not have a valid plan for QuikTrade {type}.
        </p>
        <p style={{ fontSize: "14px", color: "#666" }}>
          Please purchase a plan to continue using QuikTrade {type}.
        </p>
      </div>
    </Modal>
  );
};

export default SubscriptionCheckModal;